import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "seller-users-tab" }
const _hoisted_2 = { class: "users-filters" }
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "users-filter" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "users-component" }
const _hoisted_8 = ["onClick"]

import { computed, inject, markRaw, nextTick, ref, watch } from "vue";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import Popup from "@/components/_partials/Popup.vue";
  import UserInfoPopup from "@/components/_partials/UserInfoPopup.vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { IUserListItem } from "@/models/api/user/IUserListItem";
  import { trans } from "@/utils/trans";
  import apiClient from "@/services/api";
  import { CustomerStatus } from "@/enum";
  import { BaseIcon, MailLiveIcon } from "@/components/icons";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Users',
  setup(__props) {

  const popup = ref<typeof Popup>();
  const component = markRaw(UserInfoPopup);
  const auctionStore = useAuctionStore();
  const filter = ref<null | "active" | "pending">(null);
  const popupTitle = ref<string | null>(null);
  const emitter = inject("emitter");
  const websocketBidders = computed(() => {
    return (auctionStore.userOnLive || []).filter((user) => user.id !== auctionStore.user?.id);
  });

  const usersList = computed(() => {
    let result = [] as IUserListItem[];
    websocketBidders.value.forEach((user: IUserListItem) => {
      const uData = auctionStore.userData[user.id];
      if (uData) {
        if (user.status) {
          uData.status = user.status;
        } else {
          uData.status = "clarified";
        }
        result.push(uData);
      }
    });

    return result.sort((a: IUserListItem, b: IUserListItem) => a.full_name.localeCompare(b.full_name));
  });

  const activeCount = computed(() => {
    return usersList.value.filter((i) => i.status === "active").length;
  });

  const pendingUsers = computed(() => {
    return usersList.value.filter((i) => {
      return [CustomerStatus.NONE, CustomerStatus.PENDING].includes(i.customer_status);
    });
  });

  const filteredUsersList = computed(() => {
    let result = [] as IUserListItem[];
    if (!filter.value) {
      result = usersList.value;
    } else if (filter.value === "active") {
      result = usersList.value.filter((i) => i.status === "active");
    } else if (filter.value === "pending") {
      result = usersList.value.filter((i) => [CustomerStatus.NONE, CustomerStatus.PENDING].includes(i.customer_status));
    }

    return result;
  });

  watch(
    () => auctionStore.userOnLive,
    (nv) => {
      const userIdsNoData = [] as number[];

      if (!nv.length) {
        Object.keys(auctionStore.userData).forEach((id) => {
          auctionStore.userData[id].status = "clarified";
        });
      } else {
        nv.forEach((user: IUserListItem) => {
          if (!auctionStore.userData[user.id]) {
            userIdsNoData.push(user.id);
          } else {
            auctionStore.userData[user.id].status = user.status ? user.status : "clarified";
          }
        });
      }

      if (userIdsNoData?.length > 0) {
        apiClient
          .post(auctionStore.routes["live.users.get_users_data"], { userIds: userIdsNoData })
          .then((response) => {
            if (response.data.data?.length) {
              response.data.data.forEach((user: IUserListItem) => {
                auctionStore.userData[user.id] = user;
              });
            }
          });
      }
    },
    { deep: true }
  );

  const getUserStatus = (user: IUserListItem) => {
    let result;
    switch (user.customer_status) {
      case CustomerStatus.NONE:
      case CustomerStatus.PENDING:
        result = "pending";
        break;
      case CustomerStatus.BLOCKED:
        result = "blocked";
        break;
      default:
        result = "";
    }

    return result;
  };

  const openChat = (user: IUserListItem) => {
    emitter?.emit("on:user-message", user);
  };

  const openUserPopup = (user: IUserListItem) => {
    apiClient.post(auctionStore.routes["live.users.get_full_data"], { userId: user.id }).then((response) => {
      if (response.data.data.id) {
        popupTitle.value = user.full_name ?? null;
        popup.value?.toggleComponent(component, { data: { user: response.data.data } });
        nextTick(() => {
          popup.value?.open();
        });
      }
    });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(['users-filter', { active: !filter.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filter.value = null))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(usersList.value.length), 1),
        _createTextVNode(" " + _toDisplayString(_unref(trans)("live.user_list.tabs.bidders")), 1)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(['users-filter', { active: filter.value === 'active' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (filter.value = 'active'))
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(activeCount.value), 1),
        _createTextVNode(" " + _toDisplayString(_unref(trans)("live.user_list.tabs.active")), 1)
      ], 2),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(auctionStore).userOnLiveAnonymous || 0), 1),
        _createTextVNode(" " + _toDisplayString(_unref(trans)("live.user_list.tabs.watchers")), 1)
      ]),
      (pendingUsers.value?.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['users-filter pending', { active: filter.value === 'pending' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (filter.value = 'pending'))
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "value" }, "!", -1)
          ]), 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CustomScrollbar, { class: "custom-scrollbar controller-scrollbar" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUsersList.value, (user, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['user-row', user.status, getUserStatus(user)]),
              key: index,
              onClick: ($event: any) => (openUserPopup(user))
            }, [
              _createTextVNode(_toDisplayString(user.full_name) + " ", 1),
              _createVNode(_unref(BaseIcon), {
                class: "send-message",
                "icon-name": "mail-live",
                width: "22.636",
                height: "18.109",
                "view-box": "0 0 22.636 18.109",
                onClick: _withModifiers(($event: any) => (openChat(user)), ["stop","prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MailLiveIcon))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 10, _hoisted_8))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(Popup, {
      class: "user-info-popup",
      title: popupTitle.value,
      ref_key: "popup",
      ref: popup
    }, null, 8, ["title"])
  ]))
}
}

})